<script setup>
// Rota do editor: o modo do modelo decide a tela (HTML importado, editor
// visual v2 ou o editor de texto do modo Pessoal).
import { ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import API from 'dashboard/api/marketingEmailTemplates';
import EmailEditorV2 from './EmailEditorV2.vue';
import HtmlTemplateEditor from './HtmlTemplateEditor.vue';
import EmailTemplateBuilder from './EmailTemplateBuilder.vue';

const route = useRoute();
const { t } = useI18n();
const mode = ref(null);
const failed = ref(false);
const load = async () => {
  mode.value = null;
  failed.value = false;
  try {
    const { data } = await API.show(route.params.templateId);
    mode.value = data.mode;
  } catch (error) {
    failed.value = true;
  }
};
onMounted(load);
// A cópia editável abre na mesma rota com outro id: o Vue reaproveita a tela.
watch(
  () => route.params.templateId,
  (id, previous) => {
    if (id && id !== previous) load();
  }
);
</script>

<template>
  <div
    v-if="failed"
    class="flex h-full items-center justify-center text-sm text-n-ruby-9"
  >
    {{ t('EMAIL_TEMPLATES.LOAD_ERROR') }}
  </div>
  <div
    v-else-if="!mode"
    class="flex h-full items-center justify-center text-sm text-n-slate-11"
  >
    {{ t('EMAIL_TEMPLATES.LOADING') }}
  </div>
  <HtmlTemplateEditor
    v-else-if="mode === 'html'"
    :key="route.params.templateId"
    :template-id="route.params.templateId"
  />
  <EmailEditorV2
    v-else-if="mode === 'newsletter'"
    :key="route.params.templateId"
    :template-id="route.params.templateId"
    @mode-changed="load"
  />
  <EmailTemplateBuilder
    v-else
    :key="route.params.templateId"
    @mode-changed="load"
  />
</template>
